<template>
    <div class="header" style="margin-bottom: 2%;">
        <div class="row">
            <div class="col-6 mr-0 p-0 col-sm-6 pl-sm-1 col-md-6 col-lg-6 pr-md-5 text-left">
                <div class="title mt-3">
                    EXPLORADOR DE GRABACIONES
                </div>
            </div>
            <div class="col-6 mr-0 p-0 col-sm-6 pl-sm-1 col-md-6 col-lg-6 pr-md-5 text-right">
                <button class="btn btn-header" v-on:click="logout">
                    Cerrar Sesión
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    // import * as auth from '../../services/auth_service';
    import {
        AUTH_LOGOUT
    } from '../store/actions/auth'
    export default {
        data() {
            return {
                logo_src: 'img/logo.png',
                logo_movigoo_src: 'img/logo_movigoo.png',
            }
        },
        methods: {
            logout: async function () {
                this.$store.dispatch(AUTH_LOGOUT)
                    .then(() => {
                        this.$router.push('/login')
                    })
            }
        }
    }
</script>

<style scoped>
    .header-right-logo {
        width: 87px;
        height: 21.5px;
        object-fit: contain;
        margin-top: 22px;
        margin-bottom: 22px;
    }

    .divider {
        border-left: 1px solid;
        height: 40px;
        margin-left: 1%;
        margin-right: 1%;
    }

    .dashboard-label {
        width: 107px;
        height: 18px;
        margin-top: 24px;
        margin-bottom: 24px;
        font-family: ProximaNova;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.22;
        letter-spacing: normal;
        color: var(--black);
    }

    .header-left-logo {
        object-fit: contain;
        margin-top: 16px;
        margin-bottom: 16px;
    }

    .header {
        width: 100%;
        height: 60px;
        box-shadow: 0 3px 3px 0 rgba(175, 175, 175, 0.16);
        background-color: #ffffff;
    }

    .routerLink {
        text-decoration: none;
        color: inherit;
    }

    .router-link-exact-active {
        width: 179px;
        height: 20px;
        font-family: ProximaNova;
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: left;
        /* color: #33c2c9; */
    }

    .btn-header {
        margin-top: 0.5%;
    }
</style>